import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Spin } from 'antd';
import api from '../../api.js'; // Your API file

const PaymentFlatInvoice = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (invoiceId) {
      fetchInvoiceDetails();
    }
  }, [invoiceId]);

  const fetchInvoiceDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.getPaymentScheduleInvoiceDetails(invoiceId);
      if (response?.data?.success) {
        setInvoiceData(response.data.data);
      } else {
        setError('Invoice not found');
      }
    } catch (err) {
      setError('Failed to load invoice');
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => navigate('/dashboard/reports/payment-history');

  if (loading) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>Loading invoice...</div>
      </div>
    );
  }

  if (error || !invoiceData) {
    return (
      <div style={{ padding: '50px', textAlign: 'center', color: '#ff4d4f' }}>
        ❌ {error || 'Invoice not found'}
        <div style={{ marginTop: 16 }}>
          <Button onClick={goBack}>← Back to Payments</Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e5e7eb'
      }}>
        <Button onClick={goBack} type="default">
          ← Back to Payments
        </Button>
        <h1 style={{ margin: 0, color: '#2563eb' }}>
          Invoice: {invoiceData.invoiceNumber}
        </h1>
        {invoiceData.url && (
          <a 
            href={invoiceData.url} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              padding: '12px 24px',
              background: '#2563eb',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '6px',
              fontWeight: 500
            }}
          >
            📥 Download PDF
          </a>
        )}
      </div>

      {/* PDF Preview */}
      <div style={{ 
        background: 'white', 
        border: '1px solid #e5e7eb', 
        borderRadius: '8px', 
        marginBottom: '30px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }}>
        {invoiceData.url ? (
          <iframe
            src={invoiceData.url}
            width="100%"
            height="900px"
            title="Payment Receipt PDF"
            style={{ border: 'none' }}
          />
        ) : (
          <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
            PDF not available
          </div>
        )}
      </div>

      {/* Quick Summary */}
      <div style={{ 
        background: '#f9fafb', 
        padding: '20px', 
        borderRadius: '8px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px'
      }}>
        <div><strong>Flat:</strong> {invoiceData.flatNo} [{invoiceData.bedrooms}] {invoiceData.block && `| Block ${invoiceData.block}`}</div>
        <div><strong>Tower:</strong> {invoiceData.towerName}</div>
        <div><strong>Amount:</strong> ₹{invoiceData.totalAmount?.toLocaleString('en-IN')}</div>
        <div><strong>Paid On:</strong> {new Date(invoiceData.paidOn).toLocaleDateString('en-IN')}</div>
        {invoiceData.balance && <div><strong>Balance:</strong> ₹{invoiceData.balance.toLocaleString('en-IN')}</div>}
      </div>
    </div>
  );
};

export default PaymentFlatInvoice;
